<template>
  <div class="d-inline-flex flex-column align-items-center">

    <!-- <div class="cuadro-1">
      <div class="item">A</div>
      <div class="item">C</div>

      <div class="item">EX</div>
      <div class="item">EM</div>
      <div class="item">SSL</div>
      <div class="item">RX</div>
    </div> -->

    <div class="cuadro-1">
      <div
        v-for="item in itemsCuadro1"
        :key="item"
        class="item"
        :class="{ active: isCuadroSelected(item) }"
        @click="toggleCuadro(item)"
      >
        {{ item }}
      </div>
    </div>

    <div class="">{{ dataDiente.id }}</div>

    <div class="d-flex align-items-center">

      <svg
        viewBox="0 0 90 90"
        width="50"
        height="50"
        @click="handleClick"
      >
        <!-- TOP -->
        <polygon
          :points="points.top"
          :fill="getFill('top')"
          stroke="#001a57"
          stroke-width="1"
          @click.stop="toggle('top')"
        />
        <!-- RIGHT -->
        <polygon
          :points="points.right"
          :fill="getFill('right')"
          stroke="#001a57"
          stroke-width="1"
          @click.stop="toggle('right')"
        />
        <!-- BOTTOM -->
        <polygon
          :points="points.bottom"
          :fill="getFill('bottom')"
          stroke="#001a57"
          stroke-width="1"
          @click.stop="toggle('bottom')"
        />
        <!-- LEFT -->
        <polygon
          :points="points.left"
          :fill="getFill('left')"
          stroke="#001a57"
          stroke-width="1"
          @click.stop="toggle('left')"
        />
        <!-- CENTER -->
        <rect
          x="35"
          y="35"
          width="30"
          height="30"
          :fill="getFill('center')"
          stroke="#001a57"
          stroke-width="1"
          @click.stop="toggle('center')"
        />
      </svg>
  
      <div
        class="circle"
        :style="{ backgroundColor: getFill('circle') }"
        @click.stop="toggle('circle')"
      />
    </div>

  </div>
  
</template>

<script>
export default {
  name: "PiezaDentalSVG",

  props: {
    dataDiente: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      selected: [],

      faces: ["top", "right", "bottom", "left", "center", "circle"],
      itemsCuadro1: ["A", "C", "EX", "EM", "SSL", "RX"],

      colors: {
        top: "#4fc3f7",
        right: "#81c784",
        bottom: "#e57373",
        left: "#fff176",
        center: "#ce93d8",
        circle: "#4fc3f7",
      },
      points: {
        top:    "20,20 80,20 65,35 35,35",
        right:  "80,20 80,80 65,65 65,35",
        bottom: "20,80 80,80 65,65 35,65",
        left:   "20,20 20,80 35,65 35,35",
      }
    };
  },
  methods: {
    toggle(face) {
      const i = this.selected.indexOf(face);
      if (i > -1) this.selected.splice(i, 1);
      else this.selected.push(face);
    },


    getFill(face) {
      return this.selected.includes(face) ? this.colors[face] : "#fff";
    },


    handleClick() {
      // Si ya hay selecciones, deselecciona todo; si no, selecciona todo
      if (this.selected.length === this.faces.length) {
        this.selected = [];
      } else {
        this.selected = [...this.faces];
      }
    },


    isCuadroSelected(item) {
      return this.cuadroSeleccionado.includes(item);
    },

    toggleCuadro(item) {
      const i = this.cuadroSeleccionado.indexOf(item);
      if (i > -1) {
        this.cuadroSeleccionado.splice(i, 1);
      } else {
        this.cuadroSeleccionado.push(item);
      }
    }
  },

  computed: {
    cuadroSeleccionado: {
      get() {
        return this.dataDiente.cuadrado1 || [];
      },
      set(val) {
        this.$set(this.dataDiente, 'cuadrado1', val);
      }
    }
  }
};
</script>

<style>
.cuadro-1 {
  width: 50px;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}

.cuadro-1 .item{
  border: 1px solid #001a57;
  font-size: 9px;
  width: 22px;
  color: blue;
  cursor: pointer;
  background: #fff;
}

.cuadro-1 .item.active {
  background: #001a57;
  color: #fff;
}


.circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #001a57;
  background: #fff;
}
</style>